import { render, staticRenderFns } from "./UpdateEmployee.vue?vue&type=template&id=caad0638&"
import script from "./UpdateEmployee.vue?vue&type=script&lang=js&"
export * from "./UpdateEmployee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports